import { useQuery } from "@tanstack/react-query"

import { useQueries } from "@/hooks/useRootContext.ts"
import { normalizeProjectKey } from "@/lib/std.ts"

import type { ListFilesOptions, ProjectKey } from "@/lib/client/generated/TypeDefinitions.ts"


export function useListFiles(projectKey: ProjectKey, repo: string, commit: string | null, path: string | null, file: string | null, options: ListFilesOptions[], limit: number | null) {
  const client = useQueries().apiClient
  return useQuery({
    queryKey: ["listFiles", normalizeProjectKey(projectKey), repo, commit, path, file, ...options, limit],
    queryFn: () => {
      return client.listFiles(projectKey, repo, commit, path, file, options, limit)
    },
    placeholderData: (prev) => prev
  })
}
